import type { ImportTracksResult, MusicSource, TrackCsvMapping } from '@qlk/shared';
import { useId, useState } from 'react';

import { DongLoiCsv, FormNhapCsv as FormChung, LOP_O, type TruongCsv } from '../../../ui/index.js';

/**
 * Nhập danh mục nhạc từ CSV.
 * Khung form dùng chung ở `apps/web/src/ui/FormNhapCsv.tsx` (gộp ở bước 12.2);
 * ở đây chỉ còn bảng cột, ô chọn nguồn và câu chữ riêng của module 04.
 */

export interface FormNhapCsvProps {
  nguon: MusicSource[];
  dangGui: boolean;
  loi?: string | null;
  ketQua?: ImportTracksResult | null;
  onGui: (input: { sourceId: string; csv: string; mapping: TrackCsvMapping }) => void;
  onHuy: () => void;
}

/** Các trường nhập được, kèm tên cột mặc định gợi ý theo file xuất từ Excel. */
const TRUONG: TruongCsv<keyof TrackCsvMapping & string>[] = [
  { khoa: 'title', nhan: 'Tên bài', macDinh: 'title' },
  { khoa: 'artist', nhan: 'Nghệ sĩ', macDinh: 'artist' },
  { khoa: 'isrc', nhan: 'ISRC', macDinh: 'isrc' },
  { khoa: 'genre', nhan: 'Thể loại', macDinh: 'genre' },
  { khoa: 'moods', nhan: 'Tâm trạng', macDinh: 'mood' },
  { khoa: 'bpm', nhan: 'BPM', macDinh: 'bpm' },
  { khoa: 'durationSec', nhan: 'Độ dài', macDinh: 'duration' },
  { khoa: 'licenseEndDate', nhan: 'Hạn giấy phép', macDinh: 'license_end' },
];

export function FormNhapCsv({ nguon, dangGui, loi, ketQua, onGui, onHuy }: FormNhapCsvProps) {
  const id = useId();
  const [sourceId, setSourceId] = useState(nguon[0]?.id ?? '');

  return (
    <FormChung
      truong={TRUONG}
      dangGui={dangGui}
      {...(loi === undefined ? {} : { loi })}
      nhanGui="Nhập danh mục"
      cotAnhXa={4}
      onGui={({ csv, mapping }) => {
        onGui({ sourceId, csv, mapping });
      }}
      onHuy={onHuy}
      truocFile={
        <div>
          <label htmlFor={`${id}-nguon`} className="mb-1 block text-phu font-medium text-chu-phu">
            Nhập vào nguồn
          </label>
          <select
            id={`${id}-nguon`}
            value={sourceId}
            onChange={(e) => {
              setSourceId(e.target.value);
            }}
            className={LOP_O}
          >
            {nguon.map((n) => (
              <option key={n.id} value={n.id}>
                {n.name}
              </option>
            ))}
          </select>
        </div>
      }
      ketQua={
        ketQua ? (
          <div className="rounded-[10px] bg-ok-nen p-4 text-co-ban text-ok-chu">
            Đã thêm {ketQua.created} bài, cập nhật {ketQua.updated} bài, bỏ qua {ketQua.skipped}{' '}
            bài.
            <DongLoiCsv loi={ketQua.errors} />
          </div>
        ) : null
      }
    />
  );
}
